/**
 * 开户多语言按照页面区分
 * 内地开户以 cn 开头
 * 香港开户以 hk 开头
 * 公用页面 按照页面提取
 * 每个页面新增一个对象
 *  */
export default {
    pageTitle: '復星國際證券開戶',
    复星国际证券开户: '復星國際證券開戶',
    // 公共的
    backStep: '上一步',
    nextStep: '下一步',
    submit: '提交',
    input: '請輸入',
    'input{0}': '請輸入{0}',
    select: '請選擇',
    'select{0}': '請選擇{0}',
    reset: '重置',
    success: '完成',
    Understood: '已瞭解',
    service: '聯繫客服',
    confirmText: '確認無誤',
    returnText: '返回修改',
    tip: '溫馨提示',
    noAllowEmpty: '不能為空',
    confirm: '確認',
    determine: '確定',
    cancel: '取消',
    yes: '是',
    no: '否',
    thsTip: '您有未完成的開戶流程，請使用瀏覽器訪問以下鏈接繼續完成開戶',
    organTip: '該手機號已綁定交易賬戶，該類型賬戶即將開放線上交易功能，敬請期待！',
    know: '知道了',
    音频加载中: '音訊加載中',
    音频加载失败: '音訊加載失败',
    下载星财富APP: '下載星財富APP',
    ts: '提示',
    // 开户-身份证页面
    idCard: {
        title: '内地身份證驗證',
        des: '身份資訊僅用於開戶，我們將嚴格保護您的個人隱私',
        positive: '點擊上傳 身份證人像面',
        negative: '點擊上傳 身份證國徽面',
        negativeMO: '點擊上傳 身份證區徽面',
        photoTips: {
            title: '拍照提示',
            des: '拍攝時請確保手機橫向拍攝，證件邊框完整、文字清晰可見、亮度均勻不反光。',
        },
        photoError: {
            standard: '標準',
            missing: '邊框缺失',
            vague: '資訊模糊',
            reflex: '圖片反光',
        },
        chinaName: '中文姓名',
        pyName: '姓名拼音',
        idCardNumber: '身份證號碼',
        address: '住宅地址',
        idAddress: '證件地址',
        signing: '簽發機關',
        period: '證件有效期',
        long: '長期有效',
        birth: '出生日期',
        birthplace: '出生地點',
        addressAlikeCM: '證件地址與住宅地址、通訊地址相同',
        notAlikeAddressTip: '如證件地址與通訊位址不同，請聯繫客服進行線下開戶。',
        max76Befor: '76歲及以上用戶請',
        max76After: '進行線下開戶。',
        min18: '18歲以下用戶暫不支持開戶',
        errAccount: '身份證剩餘有效期少於6個月，請更新證件後申請開戶。',
        sfzsyyxq: '識別失敗，請重新上傳邊框完整、文字清晰的身份證照片',
        sfzyxqbhf: '身份證有效日期不合法，請重新上傳',
        sfzbwz: '身份證不清晰或邊框不完整，請重新上傳',
        sfzfyj: '非身份證原件或正式身份證，請重新上傳',
        sfzfg: '身份證反光，請重新上傳',
        qqryxxxyzjwqyz: '請確認以下資訊與證件完全一致，避免影響您的開戶進度',
        zjhm: '證件號碼',
        xmpy: '姓名拼音',
        qzysfdyz: '請注意多音字',
        zzdz: '住宅地址',
        gsfzykhhsqkh: '該身份證已開戶或申請開戶中，請退出登錄後使用原賬號登錄',
        sjh: '手機號',
        rgnwjyzhdmm: '如果您忘記原賬號的密碼，可使用手機號找回密碼。 如有疑問，請',
        zgdlshs: '上海市',
        changqi: '長期',
        dlsfzzm: 'ZM-内地-身份證-正面',
        dlsfzfm: 'FM-内地-身份證-反面',
        polyphoneWarnText: '您的姓名存在多音，請確認拼寫無誤，避免影響出入金',
        qscsfzjrxm: '請上傳身份證人像面',
        qsczfzgh: '請上傳身份證國徽面',
        gender: '性別',
        male: '男',
        female: '女',
    },
    // 开户-银行卡
    bankCard: {
        yhkyz: '內地銀聯銀行卡驗證',
        yhkyzDesc: '請上傳您的香港/澳門或海外證件照片',
        qsrhsmyhh: '請輸入/掃描內地銀聯銀行卡號',
        yhkyzDesc1: '內地銀行卡僅用於身份核驗，不適用於出入金。',
        bankCardNum: '銀行卡號',
        qsryhylsjh: '請輸入內地銀聯銀行卡預留手機號碼',
        phoneNumber: '銀行預留手機號',
        yhylsjhmbnwk: '銀行預留手機號不能為空',
        qsrnddzyxdz: '請輸入您的電子郵箱地址',
        emailAddress: '電子郵箱地址',
        jdjsfs: '結單寄送方式',
        email: '電子郵件',
        jdyy: '結單語言',
        ftzw: '繁體中文',
        dzyxyyjsjddzqywdyjtz: '電子郵箱用於接收結單等業務的郵件通知，請確認無誤',
        dzyx: '電子郵箱',
        qsrzqddzyxdz: '請輸入正確的電子郵箱地址',
        dlkhyhk: '内地-開戶銀行卡',
        yhksbcw: '認證失敗，請更換手機號碼或銀行卡重新驗證',
        bankOcrError: '銀行卡識別失敗',
    },
    // 开户-职业状况
    jobStatus: {
        xxhyx: '小學或以下',
        zhongxue: '中學',
        ykhzsxy: '預科或專上學院',
        dx: '大學',
        sshys: '碩士或以上',
        sg: '受僱',
        zg: '自僱',
        tx: '退休',
        xs: '學生',
        wy: '無業',
        nlmy: '農林牧漁',
        nlmyy: '農、林、牧、漁業',
        gyjz: '工業/建築',
        cky: '採礦業',
        zzy: '製造業',
        jzy: '建築業',
        dlrlrqjsqschgy: '電力、熱力、燃氣及水生產和供應業',
        jrsy: '金融/商業',
        jry: '金融業',
        fdcy: '房地產業',
        pfhlsy: '批發和零售業',
        zlhsfwy: '租賃和商務服務業',
        zshcyy: '住宿和餐飲業',
        xxjskx: '資訊技術/科學',
        xxcsrjxx: '資訊傳輸、軟體和資訊技術服務業',
        kxyjhjsfw: '科學研究和技術服務業',
        ggshjt: '公共/社會/交通',
        jtyscchyz: '交通運輸、倉儲和郵政業',
        jy: '教育',
        slhjhggssgly: '水利、環境和公共設施管理業',
        wshshgz: '衛生和社會工作',
        whtyyl: '文化、體育和娛樂業',
        ggglhshbz: '公共管理、社會保障和社會組織',
        jmfwxlother: '居民服務、修理和其他服務業',
        guoji: '國際',
        guojizuzhi: '國際組織',
        gaoguan: '高管',
        zhongceng: '中層',
        chujiguanli: '初級管理人員',
        putongyuangong: '普通員工',
        hehuoren: '合夥人',
        faren: '法人',
        zongjinli: '總經理',
        shaoyuyinian: '少於1年',
        yidaoliangnian: '1-2年',
        sandaowunian: '3-5年',
        liudaojiunian: '6-9年',
        shinianyishang: '10年及以上',
        jiating: '家庭',
        jianzhixinjin: '兼職薪金',
        zujin: '租金',
        tuixiujin: '退休金',
        fdctzsy: '房地產投資收益',
        jrsctzsy: '金融市場投資收益',
        qtlwbc: '其他勞務報酬',
        zyzk: '職業狀況',
        zyzkDesc: '根據監管要求收集以下信息。',
        qxzzgxl: '請選擇最高學歷',
        zgxl: '最高學歷',
        qxzzyzt: '請選擇職業狀態',
        zyzt: '職業狀態',
        selectGs: '請選擇公司',
        qsrgswzmc: '請輸入公司名稱',
        qsrgsWZmcPlaceholder: '請輸入公司完整名稱',
        gsmc: '公司名稱',
        qsrbgsdzxx: '請輸入辦公室地址資訊',
        bgsdz: '辦公室地址',
        qxzhy: '請選擇公司行業',
        hangye: '公司行業',
        qxzzy: '請選擇職位',
        zhiwei: '職位',
        qxzgznq: '請選擇工作年期',
        gznq: '工作年期',
        tzzjlydx: '投資資金來源',
        cwzk: '債務狀況',
        wzw: '無債務',
        fd: '房貸',
        qtzw: '其他債務',
        brwzwjf: '本人無債務糾紛',
        yzwjfzbzckh: '有債務糾紛，請聯繫客服進行線下開戶。',
        xzhy: '選擇行業',
        ylj: '已瞭解',
        xxBefor: '最高學歷為小學或以下請',
        xxAfter: '進行線下開戶。',
        lxkf: '聯繫客服。',
        inputCompanyInfo: '填写公司信息',
        SamePrompt: '辦公室地址與公司名稱重複，請重新輸入',
        CompanyAddressTip: '請完整填寫xx市xx區xx街道xx樓棟xx樓層xx室',
    },
    // 开户-财务状况
    Finance: {
        zyzkDesc: '根據監管要求收集以下信息。',
        xjywsr: '薪金/業務收入',
        grcx: '個人儲蓄',
        zcjc: '資產繼承',
        tzsy: '投資收益',
        zczs: '資產轉售',
        '20wanyixia': '20萬以下',
        '20wandao50wan': '20萬-50萬',
        '50wandao100wan': '50萬-100萬',
        '100wandao500wan': '100萬-500萬',
        '500wandao1000wan': '500萬-1000萬',
        '1000wanyishang': '1000萬以上',
        '100wanyixia': '100萬以下',
        // v2 淨資產/可投資金額選項（與風險測評一致）
        '250wanyixia': '250萬以下',
        '250wandao500wan': '250萬-500萬',
        '500wandao800wan': '500萬-800萬',
        '800wandao1500wan': '800萬-1500萬',
        '1500wandao4000wan': '1500萬-4000萬',
        '4000wandao8000wan': '4000萬-8000萬',
        '8000wanyishang': '8000萬以上',
        '500wandao700wan': '500萬-700萬',
        '700wandao1000wan': '700萬-1000萬',
        '100wandao300wan': '100萬-300萬',
        '300wandao500wan': '300萬-500萬',
        cwzk: '財務狀況',
        zjly: '投資資金來源',
        qxzqnsr: '請選擇全年收入(港元)',
        qnsr: '全年收入(港元)',
        qxzjzc: '請選擇淨資產(港元)',
        jzc: '淨資產(港元)',
        qxzkyztzdldzc: '請選擇可投資金額(港元)',
        kyztzdldzcjz: '可投資金額(港元)',
        qxzmnpjtzje: '請選擇每年平均投資金額(港元)',
        mnpjtzje: '每年平均投資金額(港元)',
        zzlb: '住宅類別',
        jzcbysykytzdldzc: '淨資產不應少於可投資金額。',
        lxkf: '聯繫客服。',
        sushe: '宿舍',
        yjrtz: '與家人同住',
        zufang: '租房',
        anjiewuye: '按揭物業',
        zizhiwuye: '自置物業（無按揭）',
        zigui: '自僱',
        shougu: '受僱',
        wuzhaiwu: '無債務',
    },
    // 开户-投资经验
    Investment: {
        ynyx: '1年以下',
        yzhiwunian: '1-5年',
        liuzhishinian: '6-10年',
        shinianyishang: '10年以上',
        baoben: '保本',
        zczz: '資產增值',
        gxhb: '股息回報',
        duichong: '對沖',
        tl: '套利',
        touji: '投機',
        wyyjxyspmm: '我有意進行衍生品買賣',
        wwyjxyspmm: '我無意進行衍生品買賣',
        jrjgjbdyspjz: '金融機構舉辦的衍生品講座。',
        jyjgjbyspwskc: '教育機構舉辦衍生品網上課程或教室課程。',
        yhxtgs: '銀行/信託公司',
        zqqhqq: '證券/期貨/期權',
        jjzgjz: '基金/資管公司/家族辦公室',
        jysjrhyxh: '交易所/金融行業協會',
        bxgs: '保險公司',
        ysqz: '衍生權證',
        nxz: '牛熊證',
        qhhqq: '期貨和期權',
        gpggpj: '股票掛鉤票據',
        yq: '遠期',
        dqhh: '掉期（互換）',
        tzjy: '投資經驗',
        gptzjy: '香港上市股票投資經驗',
        jytzjy: '金銀投資經驗',
        whjsptzjy: '外匯及商品投資經驗',
        agtzjy: 'A股投資經驗',
        jjtzjy: '基金投資經驗',
        tzmddx: '投資目的',
        khxys: '客戶協議書',
        wyjxyspmm: '無意進行衍生品買賣',
        yyjxyspmm: '有意進行衍生品買賣',
    },
    Derivative: {
        yspmm: '衍生品買賣？',
        nsfljyscpdzytcjfx: '您是否瞭解衍生產品的主要特徵及風險',
        wmbybyscpdzytzqlj: '我明白一般衍生產品的主要特徵。且瞭解衍生產品的主要特徵以及衍生交易中所涉及的風險。',
        nxyzsyyyxyscpxgjy: '您需要至少擁有一項衍生產品相關經驗 (多選)',
        wcjsygjsyscpzxzjfxdpxhkc: '我曾接受有關介紹衍生產品之性質及風險的培訓或課程。',
        wxshgwdgzjyywyyscpyg: '我現時或過往的工作經驗/業務與衍生產品有關。',
        wxshgwdgzjyywyyscpygyqxgzy: '我現時或過往的工作經驗/業務與衍生產品有關。與其相關職業和性質為：',
        wxshgwdyyscpygdgzjyywdfwnqw: '我現時或過往的與衍生產品有關的工作經驗/業務的服務年期為：',
        wymmyscpdjymmgdyscps: '我有買賣衍生產品的經驗。買賣過的衍生產品是：',
        yscpbkdbxyysqcnxzgpzsqh:
            '衍生產品包括但不限於衍生權證、牛熊證、股票/指數期貨及期權、商品結構性產品及交易所基金等，無論是否於交易所進行交易。',
        nyqrwytzyscpbckh: '您已確認無意投資衍生產品，本次開戶將不會開通衍生品交易權限。',
    },
    selectAccount: {
        xzzh: '選擇賬戶',
        zqzhlx: '證券賬戶類型',
        jinjinzh: '理財賬戶',
        shichangleixing: '市場類型',
        yiliaojie: '已瞭解',
        xinjinzhanghu: '現金賬戶：',
        sybrzyzjjxjy: '使用本人自有資金進行現金交易，不允許借貸融資，不允許沽空股票。',
        rzzh: '保證金賬戶：',
        ycbzjzhhmzzh: '亦稱融資賬戶或孖展賬戶。除可使用自有資金交易，亦可使用融資交易功能。',
        rongzi: '融資',
        sztggzhxfxhljr:
            '是指通過該賬戶向復星國際證券借入資金進行買入股票，起到放大交易槓桿的作用。可放大收益率，但也會放大風險。請根據自身風險承受能力選擇賬戶類型。',
        ktlczhh: '開通理財賬戶後，您可以購買場外基金、場外債券產品；若不開通理財賬戶，則無法購買上述產品',
        rzzhanghu: '保證金賬戶',
        xianjinzhanghu: '現金賬戶',
        tradeClasses: '交易品種',
        ganggu: '港股',
        meigu: '美股',
        hushengangtong: 'A股通',
        qixian: '期權',
        licai: '理財',
        zbkxzsclx: '暫不可選擇市場類型',
        btxbkqx: '必選項不可取消',
        noSelectOpenFund: '暂不可取消選擇理財賬戶',
        CashAccountTip: '使用本人自有資金進行交易，不允許借貸融資。',
        MarginAccountTip: '也稱「融資賬戶」或「孖展賬戶」，除可使用自有資金進行交易，也可以股票作抵押，借用證券公司資金進行融資交易。',
        selectAccountToast: '請選擇證券賬戶類型',
        viewMore: '查看更多',
        marginAccountDesc1: '又稱【融資賬戶】或【孖展賬戶】，允許客戶以股票作為抵押，借用證券公司资金進行融資交易',
        marginAccountDesc2: '支持交易多市場股票、<span class="bold">美股期權</span>、基金、債券',
        cashAccountDesc1: '僅可使用自有資金交易',
        cashAccountDesc2: '支持交易多市場股票、基金、債券',
        recommend: '推薦',
        noDerivative: '您暫未開通衍生品權限，無法開通期權品類，請返回投資問卷頁面進行開通',
        zbzcqx: '港美A股默認開通，暫不支持取消',
        zbzcqxCn: '港美股默認開通，暫不支持取消',
        derivativeRole: '衍生品權限',
        derivativeNoOpen: '已開通',
        derivativeNoOpenTips: '期權市場需要開通衍生品權限',
        derivativeOpenTips: '期權市場需要開通衍生品權限，不開通則無法進行期權交易',
        derivativeOpenSuccess: '已開通衍生品權限',
        derivativeNoOpenError: '未開通衍生品權限，無法開通期權市場',
    },
    disclosure: {
        brdpoffxhlzq: '本人的配偶非復星國際證券有限公司的保證金客戶。',
        brhbrdpowygtkg: '本人或與本人的配偶未有共同控制任何復星國際證券有限公司的公司保證金客戶35%或以上之投票權。',
        brbdblyfxzq: '本人不代表另一復星國際證券有限公司的保證金賬戶行事。',
        brbmyyfxhl: '本人並沒有與復星國際證券有限公司的另一保證金客戶代表同一第三方行事。',
        brbsfxhldsysyr:
            '本人不是復星國際證券有限公司任何其他保證金賬戶的實益擁有人，或不會從復星國際證券有限公司任何其他保證金賬戶的交易中取得商業或經濟利益或承擔商業或經濟風險。',
        brmyxfxhllykhdb: '本人沒有向復星國際證券有限公司的另一保證金客戶提供擔保或收取擔保。',
        brbmyyfxhllykhdbfz: '本人並沒有與復星國際證券有限公司的另一保證金客戶由同一擔保人擔保財務負債。',
        brwbzhzzsyr: '本人為本賬戶的最終實益擁有人。',
        brhbzhdzzsyrwfzqcpr: '本人或本賬號的最終實益擁有人非根據香港《證券及期貨條例》登記的持牌法團或註冊機構之持牌代表或僱員。',
        bryfxhlcprmyqqgx: '本人與復星國際證券有限公司的持牌代表或僱員並沒有親戚關係。',
        brhbrdygrsmycz:
            '本人或本人的“有關聯人士”（包括有關本人的未成年子女的賬戶及有關本人擁有實益權益的賬戶）於復星國際證券有限公司並沒有操作/持有其他账户。',
        brjpobbszygz:
            '本人及/或本人的配偶、合夥人、子女、父母或近親並不是現時/曾經於政府或國際組織被賦予任何重要公職，例如國家或政府元首，高級政治家/高級政府官員，高級行政人員或上述人士的家人或有密切連絡人士（定義詳見《打擊洗錢及恐怖分子資金籌集（金融機構）條例》）',
        brbsmgjm: '本人不是美國居民、公民或未持有美國永久居民身份證（綠卡）。',
        sfpl: '身份披露',
        rldsfyxxbyz: '如您的身份與選項不一致，請聯繫客服進行線下開戶。',
        yynymgsfzbzswfkh: '如您為美國人身份，請聯繫客服進行線下開戶。',
        yes: '是',
        no: '否',

        AML_title: '反洗錢風險提示',
        AML_des: '由於您的名字與某些洗錢案例名字吻合，因此，請您仔細閱讀後並確認以下問題。',
        AML_pop1: '本人未曾經涉及違法或違反監管守則而被捕/受審/被判刑/被紀律處分',
        AML_pop2: '本人不存在（或可能涉及）任何訴訟（民事和刑事）、仲裁、政府處罰、政府調查或任何其他爭議',
        AML_pop3:
            '本人或本人的直系親屬不是現時/曾出任有關之政府公職（包括：國家或政府元首、重要政客、高級政府官員、高級司法官員、高級軍方官員、重要政黨的幹事、國有企業高級行政人員或宗教領袖） 或國際組織政治人物？ 更詳細定義見《打擊洗錢及恐怖分子資金籌集（金融機構）條例》',
        AML_tips: '若不滿足選項條件，請聯繫客服進行線下開戶。',

        AML_que1: '您或您的直系親屬是否曾為國家/政府機關及事業單位高級公職人員？',
        AML_que2: '您是否曾涉及金融監管機構（如：人民銀行，證監會，保監會，銀監會）的調查或處罰？',
        AML_que3: '您是否曾涉及洗錢、金融犯罪、資助恐怖主義或其他非法活動（刑事）而被調查/起訴/定罪？',
        AML_que4: '您是否曾被任何政府機構、監管機構、或國際組織列入制裁名單？',
        AML_que_tips: '若不滿足選項條件，請聯繫客服進行線下開戶。',
        AML_desc_error: '詳細描述不能為空',
        AML_desc_placeholder: '請補充詳細描述',
    },
    TaxInfo: {
        shuwuxinxi: '稅務資訊',
        shuwuxinxi_des:
            '根據國際通用的《共同申報準則》(CRS)規定，我們需要收集您的稅務國家/地區及稅務編號，這些信息可能會與您稅務國家/地區的稅務機關共享，僅用於稅務申報用途。',
        sbshenfen: '申報稅務身份',
        shuwudiqu: '稅務地區',
        shanchu: '刪除',
        qxzgjhdq: '請選擇稅務國家/地區',
        swgjdq: '稅務國家/地區',
        qsrswbh: '請輸入稅務編號',
        swbh: '稅務編號',
        tjxswxx: '添加新稅務資訊',
        xinxi: '資訊',
        qxzw8gjdq: '請選擇W-8BEN國家/地區',
        w8gjdq: 'W-8BEN國家/地區',
        gjdq: '國家/地區',
        qsryjjzdz: '請輸入永久居住地址',
        yjjzdz: '永久居住地址',
        yiliaojie: '已瞭解',
        brsmbrwxlsfzswjm: '本人聲明本人為下列司法管轄區之稅務居民。',
        qtxnwswjmssdsygx:
            '請填寫您為稅務居民所屬的所有司法管轄區及相應的稅務編號（香港包括在內）。如果您對您的稅務居民司法管轄區有任何疑問，請聯絡您的稅務顧問。',
        rnsxgjm: '如你是香港稅務居民，稅務編號是香港身份證號碼。如你是中國稅務居民，稅務編號是中國公民身份證號碼。',
        xmknwnzdtr: '下面可能已為你自動填入相關資訊，如與實際情況不符，請你重新填寫。',
        qhdywzzdzzktxywpy: '請核對英文住宅地址 ，只可填寫英文/拼音。',
        zgnd: '中國內地',
        qrscgtswxxm: '確定刪除該條稅務資訊嗎？',
        swbhcf: '稅務編號重複，請重新填寫',
        swgdcf: '稅務國家/地區重複，請重新選擇',
        qtxnwyjjmssdswsfgxqjswbh: '請填寫您為永久居民所屬的稅務司法管轄區及稅務編號',
        hkfyzbshsc: '香港非永居用戶不能刪除稅務資訊',
        yndswxxjbsbzhxgjsj: '您的稅務資訊將被申報至香港稅局',
        qsrpy: '不允許輸入漢字',
        upTitle: '上傳文件證明',
    },
    W8popTipText: 'W8國家需在國籍或稅務所屬國家中選擇，永久居住地址與住宅地址一致。若有疑問，請',
    填写须知: '填寫須知',
    understand: '已瞭解',
    Country: {
        qsrdqgjzss: '請輸入地區關鍵字搜索',
        cydq: '常用地區',
    },
    riskDisclosure: {
        fengxianpilu: '風險披露',
        wqcmbgpjgzd: '我清楚明白“股票價格漲跌，買賣證券均可帶來虧損或盈利”；',
        wqcmbkhxyzxcddzjyfx: '我已清楚明白客戶需要自行承擔電子交易帶來的風險及損失；',
        wyqcmbmgddjg: '我已清楚明白美股及其他海外證券受當地證監會監管，而非香港證監會監管。',
        nbxwztwfxyp: '您必須完整聽完風險披露音訊才能繼續開戶',
        ypjzz: '音訊加載中',
        图片加载中: '圖片加載中',
        yy: '粵語',
        putonghua: '普通話',
        wyjydjmb: '我已經閱讀及明白',
        khxys: '客戶協議書',
        nr: '內容；',
        cpdb: '持牌代表：',
        pzh: '牌照號',
        bs: '倍速',
        yue: '約',
        fen: '分',
        miao: '秒',
        请点击下方播放按钮听取完整风险披露音频: '請點擊下方播放按鈕聽取完整風險披露音頻',
        复星国际证券请您仔细阅读风险披露: '復星國際證券請您仔細閱讀風險披露',
        riskTitle: '風險披露內容',
        riskCheck: '本人已經詳細了解、清楚明白、完全接受並同意遵守以上披露內容',
        riskIntro: '您好，我是{name}，持有香港證監會發出的證券交易牌照，中央編號是{license}。',
        riskIntro2:
            '在您的證券戶口開通之前，請您仔細閱讀客戶協議書和風險披露聲明書，如果對以上兩份資料有任何疑問，請與我們聯絡，我們會盡快為您解答有關的問題。',
        riskIntro3: '請您留意風險聲明中以下幾個要點。',
        riskContent1: '1. 投資涉及風險，股票價格可升可跌，買賣證券均有可能帶來損失或盈利。',
        riskContent2: '2. 如果當您要進行衍生品的交易，例如牛熊證、認股權證等，已知悉其附帶的風險更大，價格有機會跌至為零。',
        riskContent3: '3. 已清楚客戶需自行承擔電子交易帶來的相關風險及損失。',
        riskContent4: '4. 如果您有意買賣美股或其他海外證券，已清楚美股或其他海外證券受當地證監會監管，而非香港證監會監管。',
        riskEnd: '最後，您同意並接受復星國際證券的客戶協議書和風險披露說明書，請您在相關項目下面打勾，謝謝您。',

        riskOptionIntro:
            '尊敬的客戶，您好，我是復星國際證券有限公司的{name}，持有香港證監會發出的證券交易牌照，中央編號是{license}。在您的證券或美股期權賬戶開通之前，請您仔細閱讀客戶協議書和風險聲明披露文件，若有疑問，請與我們聯絡，我們會盡快為您解答有關的問題。以下我會簡單為您說明買賣證券及美股期權風險聲明中的幾個要點。',
        riskOptionContent1:
            '第一，投資涉及風險，證券價格可升可跌，買賣證券均有可能帶來損失或獲利。而美股期權交易具有高風險性，您可能蒙受的虧損會超過初始投資金額，甚至可能需要追加保證金。若未能及時存入，您的未平倉合約可能會被強制平倉，但您仍需對帳戶內的任何虧損負責。',
        riskOptionContent2:
            '第二．進行衍生品的交易都具有時間損耗的風險，假若其他情況不變，衍生權證隨著到期日臨近，衍生權證的時間價值會逐漸減少，可能導致期權價值大幅下降甚至歸零。衍生產品亦都可能涉及槓桿的元素，雖然可能放大收益，但也會放大虧損，甚至可能導致損失超過初始投資金額。',
        riskOptionContent3:
            '第三，流動性風險和執行風險也需注意。在某些市場情況下，期權合約可能因流通量不足而難以在理想價格買入或賣出。若您選擇行使期權，還可能面臨標的資產無法及時交割或結算的風險。',
        riskOptionContent4:
            '第四，如果投資在受外國法律管轄的任何資產或投資是由受外國法律管轄的一方發行，可能涉及額外風險，且您所在地的監管機構可能無法強制執行其他地區的規則。因此，建議您在交易前詳細了解相關市場的規則，並諮詢專業顧問。',
        riskOptionEnd1: '最後，客戶需自行承擔電子交易帶來的相關風險及損失。',
        riskOptionEnd2:
            '在您開立證券交易賬戶或美股期權交易賬戶前，請務必仔細閱讀並完全理解本風險披露聲明的全部內容。證券投資及美股期權交易均涉及風險，請您根據自身的投資經驗，財務狀況，投資目標及風險承受能力，審慎考慮是否適合進行相關投資。更詳細的風險披露，請詳閱美股期權交易的風險聲明披露文件。若您有任何疑問，歡迎隨時聯繫我們。',
        riskOptionEnd3: '感謝您的聆聽，祝您投資順利！',
    },
    SignAgreement: {
        qianshuxieyi: '簽署協議',
        wyydqb: '我已閱讀全部',
        khwj: '開戶文件',
        yljxgfxbzy: '，瞭解了相關風險並自願在復星國際證券開戶',
        dianjiqianming: '點擊簽名',
        wqrystgdbrsyzljwzsyx:
            '我確認以上提供的本人的所有資料和文件均為有效，真實，完整，準確及最新，且我授權復星國際證券從其認為合適的來源驗證該等資料。我進一步同意如該等資料有任何變更會從速以書面形式通知復星國際證券。我確認，復星國際證券有權根據其認為恰當的任何資料來源以更新其現存的資料。如有需要復星國際證券可要求我確認有關資料。',
        swzwzm: '稅務自我證明聲明',
        khxys: '客戶協議書',
        gryxtk: '個人資料(私隱)條款',
        yhdlxy: '用戶登錄協議',
        bzjzhcssqxy: '保證金賬戶常設授權協議書',
        mpgqjyxy: '美股期權交易協議',
        mghqshm: '美股及美股期權聲明協議',
        khsmjqr: '客戶聲明及確認',
        fybz: '費用標準',
        tbkhfxplsm: '特別客戶-風險披露聲明',
        yiqueren: '已確認',

        yProtocol1: '我已閱讀',
        yProtocol2: '《資產轉移確認聲明》',
        yProtocol3: ', 同意將雲鋒證券資產轉移至復星國際證券',
        yProtocolTips: '如您不同意勾選《資產轉移確認聲明》，開戶成功後您需於app提交線上轉倉申請。',
        goonSign: '繼續簽名',
        pageTitle: '復星國際證券',
        dzqmf: '電子簽名法',
        wzsm: '偽證聲明',
        taxInfoAgreement: '稅務信息與預扣稅協議',
    },
    Signature: {
        qzfknhxqsndmz: '請在<span style="color: #ff6907;">方框內</span>橫向簽署你的名字：',
        chongxie: '重寫',
        wancheng: '完成',
        kehuqianming: '客戶簽名',
    },
    LivingWitness: {
        rlyz: '人臉驗證',
        qasldzpsydsmbrmbsp: '請按示例動作拍攝一段3秒的本人面部視頻',
        shili: '示例',
        banshenzhengmian: '半身正面照片',
        paishetishi: '拍攝提示',
        qbzmbwz: '請確保臉部完整，保持光線充足;',
        spschrbmykcxps: '視頻上傳後，若不滿意可點擊重新拍攝。',
        dqllqbbbzcsxtqqhllq: '當前瀏覽器版本不支持攝像頭，請切換瀏覽器',
        yzsbqcxyz: '驗證失敗，請重新驗證',
        lzspsbqcxlz: '錄製視頻失敗，請重新錄製',
        qzydddkym: '請在移動端打開頁面',
        rlyztg: '人臉驗證通過',
        spwjgdqcxsc: '視頻文件過大，請重新上傳',
        htsbtp: '活體識別圖片',
        videoShortMsg: '視頻過短，請重新上傳',
        videoLongMsg: '視頻過長, 請重新上傳',
        uploadSuccessMsg: '上傳成功',
        yuji: '預計',
        status_calculating: '正在計算文件校驗碼...',
        status_init: '初始化',
        status_uploading: '正在上傳...',
        status_completing: '正在處理文件...',
        status_done: '上傳完成',
        status_verifying: '認證中',
        vidioLargeTip: '當前上傳視頻過大，請您前往App進行開戶。如有疑問，請聯系客服',
    },
    CaApply: {
        zssq: '證書申請',
        zlyjtxwbdjljck: '資料已經填寫完畢，點擊鏈接查看開戶書',
        wqrsq: '我已閱讀並同意',
        confirmAfterText: '確認申請粵港互認電子證書，申請成功後同意使用證書簽署開戶書',
        yghrdzzs: '粵港互認電子證書',
        sqcghtysyzs: '，申請成功後同意使用證書簽署開戶書',
        grkhsqb: '個人開戶申請表',
        zwzmbg: '自我證明表格（個人）',
        pdfwjz: 'pdf文件未載入',
        rvckwjqdjysjzllqdk: '如需查看文件，請點擊右上角在瀏覽器中打開',
        wjjzz: '文件載入中',
        wjjzsb: '文件載入失败',
    },
    OpenStatus: {
        ryyw: '如有疑問，請',
        bhyy: '駁回原因',
        sm: '說明',
        xingming: '姓名：',
        henglihao: '星財號：',
        lianxikefu: '聯繫客服',
        khzlshz: '開戶資料審核中',
        khzltbz: '開戶資料同步中',
        yjydlrkt: '我們正在加速審核，預計1-2個工作日內審核完畢',
        zlshbtgDesc: '請修改或確認資訊以繼續完成開戶',
        khcgDesc: '感謝您的信任，讓我們一起開啟財富之旅',
        age65To75Tip: '您的開戶申請已提交，若資料審核無誤，1個工作日內會有客服專員電話聯系您確認信息，請留意接聽。',
        zlshbtg: '審核不通過',
        bckhzl: '補充開戶資料',
        bczl: '補充資料',
        khcg: '開戶成功',
        gxkhcg: '恭喜您開戶成功！',
        crzj: '存入資金',
        khsqytj: '開戶申請已提交',
        khqqtjsb: '開戶請求提交失敗',
        lymcppsbl: '路由名稱匹配失敗了',
        shz: '審核中',
        bh: '駁回',
        wc: '完成',
        redirecting: '跳轉中',
    },
    home: {
        selectOpenAccountType: '選擇開戶類型',
        hkTitle: '網上轉賬開戶',
        hkSubtitle: '香港銀行賬戶轉賬一萬港幣',
        planFile: '請準備以下材料',
        PHK_IdcardFile: '海外居民請提供護照，港澳居民請提供身份證或護照',
        PHK_HZFile: '非內地護照/身份證',
        PHK_AddressFileDesc: '由指定機構提供的，包括您的姓名和地址的文件',
        PHK_AddressFile: '有效期3個月內的地址證明',
        PHK_money: '香港銀行賬戶',
        PHK_moneyDesc: '通過同名香港銀行賬戶，轉賬至復星國際證券以作開戶認證，單筆入金金額不少於等值 10,000 港元',

        cnTitle: 'CA見證開戶',
        cnSubtitle: '擁有海外身份證件的內地籍人士',
        PCN_HK: '香港、澳門或其他海外身份證件',
        PCN_HKDesc: '香港、澳門或其他海外身份證件',
        PCN_IdCard: '中國內地居民身份證',
        PCN_IdCardDesc: '有效期大於6個月，且已年滿18周歲',
        PCN_BankCard: '中國內地銀行卡',
        PCN_BankCardDesc: '僅用於身份核驗，不適用於出入金',
        No_OpenCnAccount: '非常抱歉，目前無法為中國境內投資者提供開戶服務。',

        bryydtykt: '本人同意開通',
        dzjyfw: '電子交易服務',
        bryydbty: '本人已閱讀並同意',
        khxys: '客戶協議書',
        xyb: '下一步',
        qh: '切換',
        changeCN: '中國內地居民身份證開戶',
        changeHW: '香港/澳門居民身份證及護照（非內地）開戶',
        changeCnOrHwBefor: '當前的開戶申請將會失效，確認繼續嗎？',
        khsqtjsb: '開戶申請提交失敗',
        changeOpenAccount: '切換開戶方式',
    },
    Step: {
        xxyz: '資訊驗證',
        fxpl: '風險披露',
        rlyz: '人臉驗證',
        rjrz: '入金認證',
    },
    UploadFile: {
        scz: '上傳中...',
        jzz: '加載中...',
        scsbqcs: '上傳失敗, 請重試',
        xztp: '選擇圖片',
    },
    fxhlkh: '復星國際證券開戶',
    AccountStatus: {
        xingming: '姓名：',
        henglihao: '星財號：',
        bhyy: '駁回原因',
        lcjd: '流程節點',
        khzlshz: '開戶資料審核中',
        khzlxg: '開戶資料',
        btg: '不通过',
        zlshytg: '資料審核',
        ytg: '已通過',
        ljxg: '立即修改',
        crzj: '存入資金',
        bckhzl: '補充開戶資料',
        zjdzqrz: '資金到賬確認中',
        zjdzyc: '資金到賬',
        yc: '失败',
        zjydz: '資金到賬',
        ydz: '已確認',
        jxcrzj: '繼續存入資金',
        zrgp: '轉入股票',
        lxkf: '聯繫客服',
        yjydlrkt: '我們正在加速審核，預計1-2個工作日內審核完畢',
        qqrhxgqrxxyjxwckh: '請修改或確認資訊以繼續完成開戶',
        khcg: '開戶成功',
        zwrjqtjrj: '暫未入金，請提交入金',
        ljrj: '立即入金',
        zcsqqrz: '轉倉申請確認中',
    },
    hk_IDcard: {
        xgjmsfz: '香港居民身份證',
        amjmsfz: '澳門居民身份證',
        huzhao: '護照（非內地）',
        man: '男',
        woman: '女',
        sfxxyz: '資訊驗證',
        sfxxjyykh: '身份資訊僅用於開戶，我們將嚴格保護您的個人隱私',
        guojidiqu: '國籍(地區)',
        brssxgdyjjm: '本人是所選國籍(地區)的永久居民',
        yjjum: '您當前是否為香港/澳門或海外永久居民',
        khvjxx: '開戶證件信息',
        khtips: '提示：港澳通行證不可作為開戶證件',
        txyjxx: '請填寫您的香港/澳門或海外永居證件信息',
        txfyjxx: '請填寫您的香港/澳門或海外非永居證件信息',
        qxzgjdq: '請選擇國籍(地區)',
        zjlx: '證件類型',
        qxzzjlx: '請選擇證件類型',
        qfgjdq: '簽發國家/地區',
        qxzqfgjdq: '請選擇簽發國家/地區',
        zjhm: '證件號碼',
        qsrzjhm: '請輸入證件號碼',
        szhzm: '數字或字母',
        xgjmsfzwxsrkh: '香港居民身份證無須輸入括弧，例:A1234567',
        证件号码格式错误: '證件號碼格式錯誤',
        qsrzjhm: '請輸入證件號碼',
        scsfz: '上傳證件',
        qscjmsfz: '點擊上傳 居民身份證/護照人像面',
        djshchid: '點擊上傳 居民身份證人像面',
        djshchrxm: '點擊上傳 護照人像面',
        yjinfo: '永居證件信息',
        qscyjzjxx: '請填寫您的永居證件信息',
        qscsfzjrxm: '請上傳身份證件人像面，中國內地身份證需同時上傳人像面和國徽面',
        MO_qscsfzjrxm: '上傳身份證件人像面，中國內地身份證與澳門居民身份證需同時上傳人像面和徽章面',
        yjxxtsh: '上傳所選國籍(地區)永居居民身份證件或護照',
        zgxg: '中國香港',
        zgam: '中國澳門',
        gsfzykhhsqkhz: '該身份證已開戶或申請開戶中，請退出登錄後使用原賬號登錄。',
        sjh: '手機號',
        rgnwjyzhdmm: '如果您忘記原賬號的密碼，可使用手機號找回密碼。 如有疑問，請',
        tjxxsb: '提交資訊失敗',
        qxxzgqdq: '請先選擇國籍(地區)',
        sxgj: '所選國籍（地區）請',
        jxxxkh: '進行線下開戶。',
        chIdCard: '身份證',
        chPassport: '中國護照',
        chPassportError: '中國護照格式錯誤',
    },
    hk_ProofAddress: {
        dzzm: '地址證明',
        dzzmlxbksdtzd: '地址證明類型包括水電通知單、電信、信用卡對賬單等',
        jzgjdq: '居住國家/地區',
        qxzjzgjdq: '請選擇居住國家/地區',
        jzcs: '居住城市',
        qtxjzcs: '請填寫居住城市',
        xxdz: '詳細地址',
        qtxxxdz: '請填寫詳細地址',
        qwztxjdldlc: '請完整填寫xx街道xx樓棟xx樓層xx房，與地址證明相同',
        zzdzytxdzxt: '住宅地址與通訊地址相同',
        rzzdzytxdzbt: '如住宅地址與通訊地址不同，請聯繫我們進行線下開戶。',
        scdzzm: '上傳地址證明',
        scsl: '上傳示例',
        dzzmyxqzsgyn: '地址證明有效期在三個月以內；',
        grxmrqjdzxxxwz: '個人姓名、日期及地址資訊需完整；',
        scyjdzb: '上傳原件電子版、照片或掃描件；',
        qwscpsddnpmzp: '請勿上傳拍攝的電腦螢幕照片; 請確保地址證明文件完整，勿進行裁剪。',
        qscdzzm: '點擊上傳地址證明',
        qqrndzzdzydzzmwqyz: '請確認您的住宅地址與地址證明完全一致，避免影響您的開戶進度。',
        zzdz: '住宅地址：',
    },
    hk_UserInfo: {
        grxxtx: '個人資訊填寫',
        sfxxjyykh: '身份資訊僅用於開戶，我們將嚴格保護您的個人隱私',
        qsrxm: '請輸入中文姓名',
        ywxm: '英文姓名',
        xm: '中文姓名',
        xing: '請輸入英文姓',
        ming: '請輸入英文名',
        xingbie: '性别',
        csrq: '出生日期',
        csdd: '出生地點',
        qxzxb: '請選擇性別',
        qxzcsrq: '請選擇出生日期',
        qxzcsdd: '請選擇出生地點',
        qsrnddzyxdz: '請輸入您的電子郵箱地址',
        dzyxdz: '電子郵箱地址',
        jdjsfs: '結單寄送方式',
        dzyj: '電子郵件',
        jdyy: '結單語言',
        xzcsd: '選擇出生地',
        ylj: '已瞭解',
        lxkf: '聯繫客服。',
        zgdlshs: '上海市',
        qsrzqddzyxdz: '請輸入正確的電子郵箱地址',
        man: '男',
        woman: '女',
        s8syxzbzc: '18歲以下用戶暫不支持開戶',
        l5syszbzc: '76歲或以上用戶暫不支持開戶',
        ftzw: '繁體中文',
    },
    transitionGold: {
        dqjd: '當前進度',
        zlytj1: '資料已提交，存入資金驗證身份繼續開戶',
        zlytj2: '資料已提交，存入資金/轉入股票繼續完成開戶',
        xzrjbz: '選擇入金幣種',
        zcgymy: '支持港元、美元及離岸人民幣入金',
        rjfxhl: '入金至復星國際證券賬戶',
        db: '單筆',
        zzfxhl: '轉至復星國際證券銀行賬戶不得少於等值',
        gangyuan: '港元',
        tzfxhlsk: '通知復星國際證券收款',
        xxzzhxtzfxhl: '線下轉賬後需通知復星國際證券收款',
        crzj: '存入資金',
        zrgp: '轉入股票',
    },
    C_SearchCompany: {
        noSearch: '查不到公司?',
        searchNoData: '暫無搜索結果',
        inputCompanyInfo: '填寫公司資訊',
    },
    openAccountStrictContent: {
        confirmButtonText: '切換開戶方式',
        tip1: '非常抱歉，目前無法為中國境內投資者提供開戶服務，您可以通過網上轉賬開戶繼續開通證券賬戶',
        tip2: '非常抱歉，目前無法為中國境內投資者提供開戶服務',
        tip3: '溫馨提示：切換開戶方式，您當前的開戶申請將會失效',
        tip4: '請上傳身份證件人像面，中國境內投資者暫不支持開戶',
        tip5: '請前往星財富APP繼續完成開戶',
        tip6: '請授權使用您當前的位置後再繼續進行開戶',
        gotoAppBtn: '立即前往',
        gotoSettingBtn: '去設置',
        getAppLocationToastMessage: '獲取中...',
    },
    mrStatus: {
        tip: {
            span1: '為提升系統體驗，正在進行',
            span2: '系統維護',
            span3: '。開戶、出入金、換匯、提交訂單等操作將受影響無法使用。同時，系統可能不能正常查詢您的資金、持倉、交易歷史等，待系統維護後會恢復正常。如對閣下造成不便，為此深表歉意。',
        },
    },
    statement: {
        '抱歉，当前区域为受限制区域，需提供其他香港券商或银行的账户结单才可继续开户。':
            '抱歉，當前區域爲受限制區域，需提供其他香港券商或銀行的賬戶結單才可繼續開戶。',
        现有香港市场账户信息: '現有香港市場賬戶信息',
        '境内投资者，需提供境外生活或工作证明的文件，方可继续开户。': '境內投資者，需提供境外生活或工作證明的文件，方可繼續開戶。',
        '开户券商/银行': '開戶券商/銀行',
        请选择开户券商或银行: '請選擇開戶券商或銀行',
        '其他开户券商/银行': '其他開戶券商/銀行',
        '请填写其他开户券商/银行名称': '請填寫其他開戶券商/銀行名稱',
        开户姓名: '開戶姓名',
        请填写开户姓名: '請填寫開戶姓名',
        账户号码: '賬戶號碼',
        请填写账户号码: '請填寫賬戶號碼',
        上传证明文件: '上傳證明文件',
        上传图片: '上傳圖片',
        上传境外工作或生活证明文件: '上傳境外工作或生活證明文件',
        结单证明:
            "<span class='blod-txt'>1.結單證明：</span>其他香港券商或香港銀行的賬戶結單，日/月結單的PDF均可。需清晰顯示：券商或銀行名稱、賬戶姓名、賬戶號碼、帳單時間信息。",
        '证明文件支持图片、PDF': '證明文件支持圖片、PDF。',
        开户证明:
            "<span class='blod-txt'>2.開戶證明：</span>其他香港券商或香港銀行的開戶成功文件或郵件截圖。需清晰顯示：券商或銀行名稱、賬戶姓名、賬戶號碼、賬戶開通時間或郵件接收時間信息。",
        '证明文件支持图片、PDF，需为6个月以内香港券商/香港银行的完整结单，应包含券商/银行名称及账号信息。':
            '證明文件支持圖片、PDF，需爲6個月以內香港券商/香港銀行的完整結單，應包含券商/銀行名稱及賬號信息。',
        '常用券商/银行名称': '常用券商/銀行名稱',
        '找不到您要的券商/银行？可添加': '找不到您要的券商/銀行？可添加',
        其他: '其他',
        brokerName: '請輸入券商/銀行名稱',
        '当前区域为受限制区域，需提供其他香港券商或香港银行的账户结单才可继续开户。':
            '當前區域爲受限制區域，需提供其他香港券商或香港銀行的賬戶結單才可繼續開戶。',
        结单示例: '結單示例',
        稍后提交: '稍後提交',
        uploadPromise: '本人承諾上傳的信息均真實、準確、無任何虛假內容，並願意承擔因提供虛假信息所帶來的一切後果',
        proofList: {
            title: '包括但不限于 (必須是境外)',
            list: [
                '僱傭合約',
                '稅單/社保繳納記錄',
                '在職證明',
                '租房合同/房產證明',
                '電話費單據',
                '長期居留簽證/永居卡',
                '水電煤費賬單',
                '工資單/銀行流水（工資記錄）',
                '駕照/當地身份證',
                '學校錄取通知書/在讀證明',
                '工作簽證/工作許可',
                '其他符合要求的證明文件',
            ],
            '身处香港/海外证明': '身處香港/海外證明',
            开户提交日期必须于获批准逗留期间内: '開戶提交日期必須於獲批准逗留期間內',
            hkList: ['過關小票', '出入境證明文件'],
        },
        证明文件必须包括: '證明文件必須包括',
        '账单类证明文件，发出日期须在三个月以内': '賬單類證明文件，發出日期須在<span class="highlight-txt">三個月以內</span>',
        '证明文件必须包括个人姓名、个人身份证号(如有)、个人地址(如有)、发出时间、发出机构名字':
            '證明文件必須包括個人姓名、個人身份證號(如有)、個人地址(如有)、發出時間、發出機構名字',
        mainlandTitle: '中國內地客戶',
        mainlandSubtitle: '需持有香港證件或提供境外工作/生活證明',
        hkDocumentQuestion: '您是否持有香港居民身份證？',
        hkNonPermanentTitle: '香港非永居證件信息',
        uploadHkIdCard: '點擊上傳香港居民身份證人像面',
        yes: '是',
        no: '否',
        uploadOverseasProof: '上傳境外工作或生活證明',
        proofTypeInstruction: '證明類型下選其一',
        proofTypeTitle: '證明類型（提交其一即可）：',
        proofType1: '<span class="blod-txt">1. 金融類：</span>海外電子結單/通知書、海外信用卡賬單、工資單（需顯示境外公司支付工資的銀行流水）',
        proofType2: '<span class="blod-txt">2.居住類：</span>能源費單據（包括水、電、燃氣費單據）、電話費單據、境外房屋租賃證明、境外房屋持有證明',
        proofType3:
            '<span class="blod-txt">3.官方及其他證明：</span>保險單、稅單或其他政府機構出具的單據、香港駕駛證、其他境外國家/地區的駕駛證、勞動/勞務合同、在職證明',
        fileRequirementTitle: '文件要求：',
        fileRequirement1: '證明文件發出日期需在<span class="highlight-txt">三個月以內</span>。',
        fileRequirement2: '需清晰顯示您的中文或英文姓名、境外地址信息、證明文件發出日期和發出機構的完整名稱。',
        fileRequirement3: '證明文件僅支持圖片格式。',
        证明文件示例: '證明文件示例：',

        documentNotAvailable: '證件不在身邊？',
        laterSupplement: '稍後補充',
        uploadOverseasID: '請上傳您的香港/澳門或海外證件信息',
        fileRequirements: '文件要求',
        uploadDocumentFrontBack: '上傳海外證件原件正/反面。',
        supportedFileFormats: '證明文件僅支持圖片格式。',
        needHoldOverseasID: '需提供 境外工作或生活的證明',
        photoInstruction: '拍攝時請確保手機橫向拍攝，證件邊框完整、文字清晰可見、亮度均勻不反光。',
        uploadOverseasIDPhoto: '請上傳您的香港/澳門或海外證件照片',
    },
    promptText: '系統識別到當前手機號具備未完成的企業戶開戶任務，請前往Web版完成企業開戶。',

    changeChannel: {
        title: '提交確認',
        confirmButtonText: '確認修改',
        cancelButtonText: '無需修改',
        content1: '當前訪問的開戶邀請碼為',
        content2: '，與您於我司留存的邀請碼',
        content3: '不一致，請確認是否修改為最新邀請碼',
        content4: '。如有疑問，可聯繫您的客戶經理',
        incorrectChannel: '修改失敗，邀請碼不存在，請聯繫客戶經理',
    },
    // 信息補充頁面
    InformationSupplement: {
        pageTitle: '復星國際證券客服資料複核',
        supplementInfo: '補充信息',
        fundSourceTitle: '資金來源地（多選）',
        tradingFrequencyTitle: '過去一年每月交投次數',
        thirdPartyTransferTitle: '過去一年是否存在第三者匯入/匯出款項？',
        moneyLaunderingTitle: '過去一年是否牽涉關於洗錢的訴訟？',
        spouseAccountTitle: '您的配偶、您自己是否存在與配偶共同操作另一個復星國際證券的賬戶？',
        fundSourceOptions: {
            hongkong: '香港',
            mainland: '中國內地',
            macau: '澳門',
            singapore: '新加坡',
            usa: '美國',
            canada: '加拿大',
        },
        tradingFrequencyOptions: {
            lessThan1: '少於每月1次',
            '1to10': '每月1-10次',
            '11to20': '每月11-20次',
            moreThan21: '每月≥21次',
        },
        yes: '是',
        no: '否',
        other: '其他',
        prevStep: '上一步',
        confirmNext: '確認無誤，下一步',
    },
    BackgroundDisclosure: {
        politicalPersonTitle: '您是否為政治人物或其關聯人士？',
        fatfMemberTitle: '您的國籍或居住地區是否屬於FATF、APG、CFATF成員國家或地區？',
        highRiskIndustryTitle: '您是否從事涉及大量現金交易或存在洗錢高風險的行業？（如賭場、賭博、貨幣兌換、匯款代理等）',
        otherRiskFactorsTitle: '您是否存在其他可能被視為高風險的因素？',
        yes: '是',
        no: '否',
    },
}
